import { observer } from 'mobx-react-lite'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'
import { AppDivider } from 'src/component/common/analog/molecule/AppDivider'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { Paragraph } from 'src/feature/localization/component/atom/Paragraph'

type DeleteProjectModalProps = {
  open: boolean
  projectName?: string
  onClose: () => void
  onConfirm: () => void
}

export const DeleteProjectModal = observer(({
  open,
  projectName,
  onClose,
  onConfirm,
}: DeleteProjectModalProps) => {
  const { translation } = useLocalizationStore()
  const projectBuilderTranslation = translation.pages.projectBuilder

  return (
    <ModalWindow
      modalProps={{
        open,
        onClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '80%', md: '50%', lg: '30%' },
            borderRadius: '10px',
          },
        },
      }}
      titleProps={{
        textValue: projectBuilderTranslation.deleteProject(),
      }}
    >
      <AppBox sx={styles.content}>
        <Paragraph
          textValue={`${projectBuilderTranslation.deleteProject()}${projectName ? ` "${projectName}"` : ''}?`}
          m={5}
        />

        <AppDivider />

        <AppBox sx={styles.actions}>
          <AppButton
            fontSize={12}
            variant='light'
            onClick={onClose}
          >
            {projectBuilderTranslation.cancel()}
          </AppButton>

          <AppButton
            fontSize={12}
            variant='contained'
            onClick={onConfirm}
          >
            {projectBuilderTranslation.confirm()}
          </AppButton>
        </AppBox>
      </AppBox>
    </ModalWindow>
  )
})

const styles = {
  content: {
    flexDirection: 'column',
    gap: 10,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
} as const